import { createSlice } from "@reduxjs/toolkit";

interface RhapsodyReducerState {
  formOpen: { [key: string]: boolean };
}

const initialState = { inspectors: {}, formOpen: {} } as RhapsodyReducerState;

export const rhapsodyReducerSlice = createSlice({
  name: "rhapsody",
  initialState,
  reducers: {},
});

// export const {} = rhapsodyReducerSlice.actions;
